import { createAxiosInstance } from "~/plugins/axios.plugin";

class AvaliaService {
  constructor() {
    this.client = createAxiosInstance({ baseURL: process.env.PLATAFORMA_API_V2, useAccessToken: true });
  }

  clearAnswers(data) {
    return this.client.delete(`/content/academics-main/${data.academicMainId}/topics/${data.topicId}/avalia-activities/respondent-answers`);
  }
};

export default new AvaliaService();
